import { OutcomesRegistryScreen } from '../features/console';

export function PatientsPage() {
  return <OutcomesRegistryScreen />;
}
